<section
    class="card"
    [class.sb-highlight-content]="(viewportSize$ | async) !== 'xs' && showFilters"
>
    <header class="card-header align-items-center mt-n2">
        <h3 class="mb-0">
            Top holdings by
            <sb-generic-type-select
                class="d-inline-block my-n3"
                [formControl]="sortByCtrl"
                appearance="none"
                [valueKey]="false"
                [options]="sortByOptions"
            ></sb-generic-type-select>
        </h3>
        <div>
            <button
                type="button"
                class="btn btn-link me-n3 text-primary"
                (click)="toggleShowFilters()"
            >
                <tabler-icon name="adjustments-horizontal"></tabler-icon>
                <sb-notification-badge
                    *ngIf="
                        (filterInstrumentTypeCtrl.value
                            | sbFilterCount
                                : (availableInstrumentTypes$ | async)
                                : (isLoading$ | async)) +
                        (issuersCtrl.value
                            | sbFilterCount
                                : (availableIssuers$ | async)
                                : (isLoading$ | async)) as numberOfFilters
                    "
                    [@fadeInOut]
                    [tooltip]="
                        numberOfFilters === 1
                            ? 'A filter has been applied to the list.'
                            : numberOfFilters + ' filters have been applied to the list.'
                    "
                    [numberOfNotifications]="numberOfFilters"
                    iconBadge="true"
                ></sb-notification-badge>
            </button>
        </div>
    </header>
    <div
        class="card-body pt-2 overflow-hidden"
        *ngIf="sortedTopHoldings$ | async as topHoldings; else loading"
    >
        <ng-container *ngIf="topHoldings.length > 0; else noData">
            <dl
                class="sb-top-holdings-list"
                [@list]="currentPage$ | async"
                (@list.start)="onAnimationStart($event)"
                (@list.done)="onAnimationDone($event)"
            >
                <ng-container
                    *ngFor="
                        let topHolding of topHoldings;
                        trackBy: trackByFn;
                        let i = index
                    "
                >
                    <div
                        @slideInOut
                        class="sb-top-holding align-items-center"
                        [class.sb-top-holding-first]="i === 0"
                        [style.--item-index]="i + 1"
                    >
                        <div class="sb-top-holding-logo me-2 d-inline-flex">
                            <sb-company-logo
                                [stockTicker]="topHolding?.symbol"
                                [companyWebsite]="topHolding?.website"
                                [companyLogoUrl]="topHolding?.logoUrl"
                                [countryCode]="null | countryCode : topHolding.currency"
                                [type]="topHolding.privateAssetType ?? topHolding.type"
                            ></sb-company-logo>
                        </div>
                        <dt class="sb-top-holding-name ps-1">
                            <a
                                [routerLink]="topHolding.link"
                                *ngIf="topHolding.link && !topHolding.auxiliaryLink"
                            >
                                <span>{{ topHolding.displayName }}</span>
                            </a>
                            <a
                                [href]="topHolding.link"
                                (click)="
                                    $event.preventDefault();
                                    navigateByUrl(topHolding.link)
                                "
                                *ngIf="topHolding.link && topHolding.auxiliaryLink"
                            >
                                <span>{{ topHolding.displayName }}</span>
                            </a>
                            <span *ngIf="!topHolding.link">
                                {{ topHolding.displayName }}
                            </span>
                        </dt>
                        <!-- prettier-ignore -->
                        <dd
                            class="sb-top-holding-value" *ngIf="!(isLoading$ | async); else loadingValues"
                        ><sb-animated-number
                                class="font-weight-medium"
                                [useMonotypeFont]="false"
                                [value]="topHolding.value"
                                [ccy]="baseCurrency$ | async"
                                [maximumFractionDigits]="0"
                            ></sb-animated-number>
                        </dd>
                        <dd
                            class="sb-top-holding-weight"
                            matTooltip="Weight based on current market value"
                        >
                            <sb-animated-number
                                *ngIf="sortBy$ | async as sortBy"
                                class="font-weight-medium"
                                [useMonotypeFont]="false"
                                formatStyle="percent"
                                [maximumFractionDigits]="1"
                                [minimumFractionDigits]="1"
                                [value]="topHolding[sortBy.value + 'Percentage']"
                            ></sb-animated-number>
                        </dd>
                        <!-- TODO: Add daily performance once we've verified the data returned by the backend is correct-->
                        <!--<dd
                            class="sb-top-holding-performance"
                            matTooltip="Daily performance"
                            *ngIf="topHolding.dailyPerformanceRelative as performance"
                        >
                            <span
                                class="value-color d-inline-flex align-items-center justify-content-end text-nowrap"
                                [class.value-positive]="performance > 0"
                                [class.value-negative]="performance < 0"
                            >
                                <sb-animated-number
                                    class="font-weight-medium"
                                    [useMonotypeFont]="false"
                                    formatStyle="percent"
                                    [value]="topHolding.dailyPerformanceRelative"
                                ></sb-animated-number>
                                <tabler-icon
                                    style="height: 18px; width: 18px"
                                    name="circle-arrow-up"
                                    [class.sb-transform-r90]="performance === 0"
                                    [class.sb-transform-r45]="performance > 0"
                                    [class.sb-transform-r135]="performance < 0"
                                    class="ms-1 tabler-fill-circle sb-transform-animate sb-icon-sm value-color"
                                ></tabler-icon>
                            </span>
                        </dd>-->
                    </div>
                </ng-container>
            </dl>
        </ng-container>
        <ng-template #noData>
            <div role="alert" class="info mt-0">
                <strong>No holdings found!</strong>
                &nbsp; Please try and
                <button
                    class="btn link p-0"
                    style="font-size: inherit"
                    (click)="showFilters = true"
                >
                    adjust filters
                </button>
                if applied or contact
                <a href="mailto:clientservice@swimbird.se">clientservice@swimbird.se</a>
                if you need assistance.
            </div>
        </ng-template>
    </div>
    <ng-template #loading>
        <div class="card-body pt-2 overflow-hidden">
            <div
                @fadeInOut
                *ngIf="isLoading$ | async"
                class="skeleton-loader skeleton-loader-table"
                aria-busy="true"
            >
                Loading top holdings...
            </div>
        </div>
    </ng-template>
</section>
<div
    class="sb-modal-grid"
    [class.sb-modal-aside-right]="(viewportSize$ | async) !== 'xs'"
    *ngIf="showFilters"
    [@fadeInOutModal]
>
    <section
        role="dialog"
        aria-modal="true"
        aria-label="Add or update data"
        class="sb-modal-grid-container sb-modal-xs"
    >
        <header class="sb-modal-grid-header">
            <h2 class="mb-0">Settings</h2>
        </header>
        <main class="sb-modal-grid-body">
            <div class="row gy-3" *ngIf="showFilters" @fadeInOut>
                <div class="col-12 sb-tag-filters pb-3">
                    <h4 class="mb-2">Filter by instrument type</h4>
                    <sb-badges
                        size="sm"
                        allowActive="multiple-not-empty"
                        variant="primary"
                        [wrap]="true"
                        [badges]="availableInstrumentTypes$ | async"
                        (badgesChange)="filterInstrumentTypes($event)"
                    ></sb-badges>
                    <!--<sb-badges
                        *ngIf="tags$ | async as tags"
                        size="sm"
                        allowActive="multiple"
                        wrap="true"
                        (badgesChange)="filterTags($event)"
                        [badges]="tags"
                    ></sb-badges>-->
                </div>
                <div class="col-12 sb-tag-filters pb-3">
                    <h4 class="mb-2">Filter by issuer</h4>
                    <sb-badges
                        size="sm"
                        allowActive="multiple-not-empty"
                        variant="primary"
                        [wrap]="true"
                        [badges]="availableIssuers$ | async"
                        (badgesChange)="filterIssuers($event)"
                    ></sb-badges>
                </div>
                <!--
                <div class="col-12 sb-tag-filters pb-3">
                    <h4 class="mb-2">Filter by legal entity</h4>
                    <sb-badges
                        size="sm"
                        allowActive="multiple"
                        variant="primary"
                        wrap="true"
                        [badges]="availableLegalEntities"
                        (badgesChange)="filterLegalEntities($event)"
                    ></sb-badges>
                </div>-->
            </div>
        </main>
        <footer
            class="sb-modal-grid-footer row gy-3 align-items-center text-center text-sm-right"
        >
            <div class="col-12">
                <button type="button" class="btn secondary" (click)="toggleShowFilters()">
                    Hide settings
                </button>
            </div>
        </footer>
    </section>
</div>
<ng-template #loadingValues>
    <span class="sb-account-balance text-nowrap text-muted" aria-busy="true">
        Loading market value...
    </span>
</ng-template>
<div
    [class.opacity-0]="(viewportSize$ | async) === 'xs'"
    class="backdrop"
    (click)="toggleShowFilters()"
    *ngIf="showFilters"
    [@fadeInOut]
></div>
